import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface IAllSuppliers {
  supplierId: number;
  supplierName: string;
  isOnlineSupplier: boolean;
  hasOcrDocument: boolean;
}

const useGetOnlineAndOfflineSuppliers = () => {
  const call = useCallback(
    (attachmentId?: number) =>
      new Promise<IAllSuppliers[]>((resolve, reject) => {
        axiosInstance
          .get(api.getAllSuppliers(attachmentId as number))
          .then((data) => {
            resolve(
              data.data.sort((a: IAllSuppliers, b: IAllSuppliers) =>
                a.supplierName.toLowerCase().localeCompare(b.supplierName.toLowerCase())
              )
            );
          })
          .catch((error) => {
            reject(error);
          });
      }),
    []
  );

  const { execute, isLoading, value } = useAsync(call, false, undefined, []);

  return {
    getAllSuppliers: execute,
    isAllSuppliersLoading: isLoading,
    onlineOfflineSuppliers: value,
  };
};

export default useGetOnlineAndOfflineSuppliers;
